export default __webpack_public_path__ + "static/worker3-a08fda3f23abf20ef3b976effe36cdf2.jpg";